module.exports = {
  SCXMLNS : "http://www.w3.org/2005/07/scxml"
};




// WEBPACK FOOTER //
// lib/constants.js